import { render } from "./BaseLogo.vue?vue&type=template&id=51389e86&scoped=true"
import script from "./BaseLogo.vue?vue&type=script&lang=ts"
export * from "./BaseLogo.vue?vue&type=script&lang=ts"

import "./BaseLogo.vue?vue&type=style&index=0&id=51389e86&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51389e86"

export default script